import { StyledDivider } from '../../StyledDivider';
import { BottomMenuItem } from './options/BottomMenuItem';
import { CenterMenuItem } from './options/CenterMenuItem';
import { LeftMenuItem } from './options/LeftMenuItem';
import { MiddleMenuItem } from './options/MiddleMenuItem';
import { RightMenuItem } from './options/RightMenuItem';
import { TopMenuItem } from './options/TopMenuItem';

export const AlignMenuItems = [
    { label: <LeftMenuItem /> },
    { label: <CenterMenuItem /> },
    { label: <RightMenuItem /> },
    { label: <StyledDivider /> },
    { label: <TopMenuItem /> },
    { label: <MiddleMenuItem /> },
    { label: <BottomMenuItem /> },
];
